export enum SupplierTypeEnum {
    AGENT = 'Agent',
    FARMER = 'Farmer',
    BROKER = 'Broker',
}